import React from "react";

import { AuthLayout } from "@/components/layouts";

import { PasswordSetForm } from "./PasswordSetForm";

export const PasswordSetView = () => (
  <AuthLayout title="Set your password">
    <PasswordSetForm />
  </AuthLayout>
);
